import { TYPES } from './types';
import { k3taskService } from '../services';

// Get all tasks
export const getK3Tasks = (query = {}) => async dispatch => {
  try {
    const res = await k3taskService.getK3Tasks(query);
    dispatch({
      type: TYPES.ACTION_GET_K3TASKS_SUCCESS,
      payload: res.data.data
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_GET_K3TASKS_FAIL,
      payload: err.response?.data || { message: 'Error getting tasks' }
    });
  }
};

// Get a single task
export const getK3Task = (id) => async dispatch => {
  try {
    const res = await k3taskService.getK3Tasks({ id });
    dispatch({
      type: TYPES.ACTION_GET_K3TASK_SUCCESS,
      payload: res.data.data.tasks[0]
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_GET_K3TASK_FAIL,
      payload: err.response?.data || { message: 'Error getting task' }
    });
  }
};

export const getK3TaskLogs = (query) => async dispatch => {
  try {
    const result = await k3taskService.getK3TaskLogs(query);
    const data = result.data.data;
    const { task_id } = query;

    const isAppendLog = query.from_time ? true : false;
    
    if (data) {
      dispatch({
        type: TYPES.ACTION_GET_K3TASK_LOGS_SUCCESS,
        payload: { task_id, logs: data, isAppendLog }
      });
    } else {
      dispatch({
        type: TYPES.ACTION_GET_K3TASK_LOGS_FAIL,
        payload: {}
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.ACTION_CALL_API_FAIL,
      payload: {
        message: error,
      },
    });
  }
};

// Set tasks (create/update/delete)
export const setK3Tasks = (tasks, query = {}) => async dispatch => {
  try {
    const res = await k3taskService.setK3Tasks(tasks, query);
    dispatch({
      type: TYPES.ACTION_SET_K3TASKS_SUCCESS,
      payload: res.data.data
    });
  } catch (err) {
    dispatch({
      type: TYPES.ACTION_SET_K3TASKS_FAIL,
      payload: err.response?.data || { message: 'Error setting tasks' }
    });
  }
}; 